export const sectionConfig = {
  "suptitle": "آگاهانه انتخاب کنید",
  "title": "چرا فیگ انتخاب اول شماست؟",
  "reasons": [
    {
      "title": "دسترسی به قدرتمندترین مدل‌ها",
      "caption": "ما به جای مدل‌های محدود داخلی، مستقیماً از پیشگامان جهانی هوش مصنوعی نظیر OpenAI، Google، DeepSeek و XAI بهره می‌بریم تا تجربه‌ای بی‌نقص و جهانی داشته باشید.",
      "icon": "keypad"
    },
    {
      "title": "امکانات فراتر از انتظار",
      "caption": "مجموعه‌ای کامل از ابزارهای کاربردی: از تولید نمودار، جدول و فلوچارت گرفته تا چت همزمان با مدل‌های مختلف، سازماندهی چت‌ها و تحلیل انواع فایل‌ها، تصاویر و وب‌سایت‌ها.",
      "icon": "gtick"
    },
    {
      "title": "پشتیبانی فنی و تخصصی",
      "caption": "تیم فنی فیگ در تمامی روزهای هفته آماده پاسخگویی است. ما با دانش عمیق در حوزه هوش مصنوعی، شما را برای بهره‌گیری بهتر از ابزارها راهنمایی می‌کنیم.",
      "icon": "headphones"
    },
    {
      "title": "پایداری همیشگی",
      "caption": "فیگ در هر شرایطی در دسترس است. با بهره‌گیری از زیرساخت‌های متنوع و سوئیچ هوشمند بین مسیرهای بین‌المللی و داخلی، تضمین می‌کنیم که ارتباط شما با هوش مصنوعی هرگز قطع نشود.",
      "icon": "clock"
    }
  ]
}

export type SectionConfig = typeof sectionConfig
